export default __webpack_public_path__ + "tooltip.ts";